module.exports = {"information":"Informação","waiting":"Aguardando validação"};